import React, { useContext, useMemo } from 'react';
import InterfaceContext from '../../../../Context';
import { useMarkdown } from '../../../../Util';
import type { DashboardExplanation } from '@aidkitorg/types/lib/survey';

export const EXPLANATION_CENTER_ALIGNMENT_CLASSES = 'text-center [&_ul]:inline-block [&_ul]:text-left [&_ol]:inline-block [&_ol]:text-left';

export const ExplanationContent: React.FC<{ component: DashboardExplanation }> = ({ component }) => {
  const context = useContext(InterfaceContext);
  const content = useMemo(() => {
    const richText = component.content;
    if (!richText) return '';
    return richText[context.lang as keyof typeof richText] || richText.en || '';
  }, [component.content, context.lang]);
  const renderedMarkdown = useMarkdown(content);
  const alignment = component.alignment || 'center';
  return (
    <div className="w-full overflow-auto">
      <div className={`prose prose-sm max-w-none [&_*:first-child]:mt-0 [&_*:last-child]:mb-0 ${alignment === 'left' ? 'text-left' : EXPLANATION_CENTER_ALIGNMENT_CLASSES}`}>
        {renderedMarkdown}
      </div>
    </div>
  );
};
